import { reactive } from 'vue';

export const store = reactive({
  formCliente: {},
  formProduto: {},
  formFaturamento: {},
  formInformacoes: {},
  currentTab: 0,
  isUpdate: false,
  pafNFCe: false,
});
